import { Injectable, Inject, EventEmitter } from '@angular/core';
import { Http, Response, RequestOptions, Headers, Request } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { TourPlan, Route, ViewTabs, VisitDistributionRow, UserFeatures, Parameters, SectionType, User } from './model/model.class';
import { WindowRefService } from './service/windowRef.service';
import { MeetingDisplayItem, VisitEventType, VisitFilterType, MarkersEventParameters } from "./model/model.class";
import { Labels } from './model/language.model.class';

declare function getUrlTokenServiceIframe(): any;

interface ShareObj { }

@Injectable()
export class SharedService {

  server = 'https://' + window.location.host + '/';

  shareObj: ShareObj = {};

  public loaderStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  geoEvent: EventEmitter<any> = new EventEmitter();
  visitDistributionEvent: EventEmitter<any> = new EventEmitter();
  distributionstatsEvent: EventEmitter<any> = new EventEmitter();
  planadherencestatsEvent: EventEmitter<any> = new EventEmitter();
  workloadEvent: EventEmitter<any> = new EventEmitter();
  tourPlanEvent: EventEmitter<any> = new EventEmitter();
  userEvent: EventEmitter<any> = new EventEmitter();
  plannedEvent: EventEmitter<any> = new EventEmitter();
  markersEvent: EventEmitter<MarkersEventParameters> = new EventEmitter();
  authInfoEvent: EventEmitter<any> = new EventEmitter();
  loginEvent: EventEmitter<any> = new EventEmitter();
  logoutEvent: EventEmitter<any> = new EventEmitter();
  tabEvent: EventEmitter<any> = new EventEmitter();

  user: User = new User();

  id: string = "";
  date: string;
  filterDate: Date = new Date();
  date2: Date; // contain date of second map
  isSplitView: boolean = false;
  isVendorPopupVisible: boolean = false;
  currentTab: ViewTabs = ViewTabs.Map;

  private tokenServiceFolder: string;
  wheelHandler: any;
  private iframeBaseurl: string;

  private tokenObj: any;

  private readonly allowedImages: string[] = [
    'rocket', 'bulb', 'clock', 'sync', 'no-sync', 'car', 'phone',
    'red_balloon', 'cyan_balloon', 'violet_balloon', 'grey_balloon', 'greenlight_balloon', 'redlight_balloon', 'yellow_balloon',
    'meetingtype_booster_grey', 'meetingtype_oneshot_cyan', 'meetingtype_priority_violet', 'meetingtype_recurring_red',
    'outcome_orderplaced_green', 'outcome_notdemand_yellow',
    'notplanned_zero_orange', 'notplanned_prospect_lightblue', 'notplanned_otherstates_pink',
    'customer_state_cold.png', 'customer_state_new.png', 'customer_state_cold.png',
    'customer_state_prospect.png', 'customer_state_deleted.png', 'customer_state_normal.png',
    'customer_state_zero.png', 'customer_state_reactivated.png'

  ];

  private userSource = new BehaviorSubject<any>(null);
  user$ = this.userSource.asObservable();

  public viewTextSource = new BehaviorSubject<string>('');
  public viewText$ = this.viewTextSource.asObservable();

  public setViewText(text: string) {
    this.viewTextSource.next(text);
  }

  public getViewText(): string {
    return this.viewTextSource.getValue();
  }

  public visitFilterOptionsSource: BehaviorSubject<VisitEventType[]> = new BehaviorSubject<VisitEventType[]>([]);

  public visitFilterOptions$ = this.visitFilterOptionsSource.asObservable();

  public setVisitFilterOptions(options: VisitEventType[]) {
    this.visitFilterOptionsSource.next(options);
  }

  public getVisitFilterOptions(): VisitEventType[] {
    return this.visitFilterOptionsSource.getValue();
  }

  public SetVisibleUserPosition() {

    const filters = this.visitFilterOptionsSource.getValue();
    for (let i = 0; i < filters.length; i++) {
      if (filters[i].key === VisitFilterType.ShowUserPosition.toString()) {
        filters[i].visible = true;
        break;
      }
    }

    this.visitFilterOptionsSource.next(filters);
  }



  private barsVisibleSubject = new BehaviorSubject<boolean>(true);
  barsVisible$ = this.barsVisibleSubject.asObservable();

  toggleBarsVisibility() {
    this.barsVisibleSubject.next(!this.barsVisibleSubject.value);
  }

  constructor(
    @Inject(Http) private http: Http,
    private winRef: WindowRefService) {

    this.user = new User();
    this.user.Id = "";
    this.user.Username = "";

    let serverOverride = localStorage.getItem('server');
    if(serverOverride)
      this.server = serverOverride;

    this.wheelHandler = this.receiveMessage.bind(this);
  }

  public displayLoader(value: boolean) {
    this.loaderStatus.next(value);
  }

  public AuthHeaders() {
    const headers = new Headers();

    if (localStorage.getItem('signature'))
      headers.append('Authorization', localStorage.getItem('signature'));

    headers.append('domain', JSON.parse(localStorage.getItem('authInfo')).domain);
    headers.append('App-Agent', 'tpl');

    return headers;
  }

  public getTourPlan(id, date, setSecondDate?: boolean) {
    this.id = id;
    this.filterDate = date;
    this.date = this.ConvertDate(date)

    if (setSecondDate) {
      const date2 = new Date(date);
      date2.setDate(date.getDate() + 7);
      this.date2 = date2;
    }
    this.EmitTourPlan();
  }

  public getKKPI(id, date) {
    this.id = id;
    this.date = this.ConvertDate(date)
    this.EmitKPI();
  }

  public getVisitDistribution(id, date) {
    this.id = id;
    this.date = this.ConvertDate(date);
    this.EmitVisitDistribution();
  }

  public getWorkLoad(id, date) {
    this.id = id;
    this.date = this.ConvertDate(date);
    this.EmitWorkLoad();
  }

  public login(headers, username?: string, pwd?: string) {
    let that = this;
    that.authProcess(headers, username, pwd);

  }

  public authInfo() {
    let that = this;

    that.http
      .get(that.server + '/FrontendAuthenticationService.svc/v1/getauthinfo')
    .subscribe(
      response => {
        const domains = response.json();
        that.authInfoEvent.emit({ domains });
      },
      error => that.isExpired(error.status),
      () => {
        console.log('getauthinfo Complete')
      }
    );
  }

  private authProcess(headers, username?: string, pwd?: string) {
    const that = this;

    that.authProcessAPI(headers, username, pwd);
  }

  private authProcessAPI(headers, username?: string, pwd?: string) {
    const that = this;

    that.http
      .get(that.server + '/FrontendAuthenticationService.svc/Login?application=tpl', { headers: headers })
      .subscribe(
        response => {
          const responseHeader = response.headers.get('Authorization');
          const signature = responseHeader;

          localStorage.setItem('signature', signature);

          let responseJson = response.json();
          if (responseJson && responseJson.Username && !username) {
            username = responseJson.Username;
          }
          that.logIn(response.json(), username);
        },
        error => {
          if (error.status === 403 || error.status === 401)
            that.logOut('The credentials you supplied were not correct');
          else
            that.logOut('You didn\'t grant access to this resource');
        },
        () => {
          console.log('Authentication Complete')
        }
      );
  }

  public getUsers(keyword) {
    const that = this;

    const encoded = keyword ? 'name=' + encodeURIComponent(keyword) : '';

    return that.http.get(
      `${this.server}/TplWebService.svc/v1/users?${encoded}`,
      { headers: that.AuthHeaders() }
    )
      .map(response => response.json());
  }

  public logIn(userObject, username) {
    //let token = auth.AccessToken;
    let userTypes = [];
    if (userObject.Features) {
      userTypes = userObject.Features;
    }
    let accountName = "";
    if (userObject.Name) {
      accountName = userObject.Name;
    }
    this.loginEvent.emit(JSON.stringify({ id: username, userTypes: userTypes, accountName: accountName }));
  }

  public logOut(message) {
    this.logoutEvent.emit(message);
  }

  public setUser(user: User) {
    this.user = user;
    this.userEvent.emit(user);
    this.userSource.next(user);     
  }

  public setMarkers(markers, mapNumber) {
    var setSecondDate = false;    
    this.markersEvent.emit({ markers: markers, mapNumber: mapNumber });
  }

  public setPlanned(planned) {
    this.plannedEvent.emit(planned);
  }

  public SwitchTab(tab) {

    if (tab == ViewTabs.Map) this.EmitTourPlan();
    if (tab == ViewTabs.VisitDistribution) this.EmitVisitDistribution();
    if (tab == ViewTabs.WorkLoad) this.EmitWorkLoad();
    if (tab == ViewTabs.Kpi) this.EmitKPI();
    this.tabEvent.emit(tab);
    this.currentTab = tab;
    
  }

  public EmitTourPlan() {
    const that = this;
    if (this.id == null) return;
    this.displayLoader(true);
    that.tourPlanAPI(this.date);
    if (this.isSplitView) {
      that.tourPlanAPI(this.ConvertDate(this.date2), true);
    }
  }

  private tourPlanAPI(requestDate: string, setSecondDate?: boolean) {

    if (this.id.trim() != '') {
      const timeZoneOffset = - (new Date().getTimezoneOffset());
      this.http.get(this.server + '/TplWebService.svc/v2/salesrepstatuses?userid=' + this.id + '&date=' + requestDate + '&timezoneoffset=' + timeZoneOffset,
        { headers: this.AuthHeaders() })
        .map(
          response => <TourPlan>response.json()
        )
        .subscribe(
          response => {
            this.tourPlanEvent.emit({ tourPlan: response, mapNumber: setSecondDate ? 2 : 1 });
          },
          error => this.isExpired(error.status),
          () => console.log('TourPlan Complete')
        );
    }
  }

  public EmitKPI() {
    const that = this;

    if (this.id == null) return;
    this.displayLoader(true);

    that.kPIAPI();
  }

  private kPIAPI() {
    this.http.get(this.server + '/TplWebService.svc/v1/distributionstats?userid=' + this.id, { headers: this.AuthHeaders() })
      .map(distributionstatsResponse => distributionstatsResponse.json())
      .subscribe(
        distributionstats => {
          this.distributionstatsEvent.emit({ distributionstats });
        },
        distributionstatsError => this.isExpired(distributionstatsError.status),
        () => console.log('Distributionstats Complete')
      );

    this.http.get(this.server + '/TplWebService.svc/v1/planadherencestats?userid=' + this.id, { headers: this.AuthHeaders() })
      .map(planadherencestatsResponse => planadherencestatsResponse.json())
      .subscribe(
        planadherencestats => {
          this.planadherencestatsEvent.emit({ planadherencestats })
        },
        planadherencestatsError => this.isExpired(planadherencestatsError.status),
        () => console.log('Planadherencestats Complete')
      );
  }

  public EmitVisitDistribution() {
    const that = this;
    if (this.id == null) return;
    this.displayLoader(true);

    that.visitDistributionAPI();
  }

  private visitDistributionAPI() {
    this.http
    .get(this.server + '/TplWebService.svc/v1/visitdaydistribution?userid=' + this.id, { headers: this.AuthHeaders() })
    .map(response => response.json())
    .subscribe(
      response => {
        this.visitDistributionEvent.emit(response);
      },
      error => this.isExpired(error.status),
      () => console.log('VisitDistribution Complete')
     );
  }

  public EmitWorkLoad() {
    const that = this
    if (this.id == null) return;
    this.displayLoader(true);

    var fourWeeeks = 28; //days
    var fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - fourWeeeks);

    let days = 84;

    that.workloadAPI(fromDate, days);
  }

  private workloadAPI(fromDate, days) {
    const timeZoneOffset = - (new Date().getTimezoneOffset());
    var urlService = '/TplWebService.svc/v1/workload?userId=' + this.id + '&fromdate=' + this.ConvertDate(fromDate) + '&days=' + days + '&timezoneoffset=' + timeZoneOffset;
    this.http.get(this.server + urlService, { headers: this.AuthHeaders() })
      .map(response => response.json())
      .subscribe(
        response => {
          this.workloadEvent.emit(response);
        },
        error => this.isExpired(error.status),
        () => console.log('WorkLoad Complete')
      );
  }

  public isExpired(status) {
    let logout = status === 401 || status === 400;
    if (logout) this.logOut('Session expired.');
    return logout;
  }

  private ConvertDate(date) {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    let d = new Date(date);
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('');
  }

  public getColorVisitOutcome(outcomeCode) {
    let that = this;
    let color = '';

    switch (outcomeCode) {
      case 100://orderplaced
      case 110://order placed by phone
        color = 'greenlight'; // green
        break;
      case 200://no demand
      case 300://not available
      case 400://not present
        color = 'yellow'; // yellow
        break;
      default:
        color = ''; 
    }

    return color;
  }

  public getImageUrl(image: string): string {
    return this.allowedImages.includes(image)
      ? `./assets/${image}.svg`
      : ``;
  }

  public getSrcImage(image: string, path: string = ''): string {
    return this.allowedImages.includes(image) ?
      `./assets${path ? `/${path}` : ''}/${image}` : ``;
  }



  public getImageStatus(visit) {
    var pathimages = "images";
    var url = this.getSrcImage("customer_state_cold.png", pathimages);
    switch (visit.customerState) {
      case 100:
        {
          url = this.getSrcImage("customer_state_new.png", pathimages);
          break;
        }
      case 200:
        {
          url = this.getSrcImage("customer_state_cold.png", pathimages);
          break;
        }
      case 300:
        {
          url = this.getSrcImage("customer_state_prospect.png", pathimages);
          break;
        }
      case 400:
        {
          url = this.getSrcImage("customer_state_deleted.png", pathimages);
          break;
        }
      case 500:
        {
          url = this.getSrcImage("customer_state_normal.png", pathimages);
          break;
        }
      case 600:
        {
          url = this.getSrcImage("customer_state_zero.png", pathimages);
          break;
        }
      case 700:
        {
          url = this.getSrcImage("customer_state_reactivated.png", pathimages);
          break;
        }
    }
    return url;
  }

  public getMeetingPointPopup(item: MeetingDisplayItem): MeetingDisplayItem {
    const outcome = item.outcome || '';
    let icon_on_top_left = "";
    switch (item.origin.toString()) {
      case "400":
        icon_on_top_left = "rocket";
        break;
      case "300":
        icon_on_top_left = "bulb";
        break;
      default:
        if (item.eventType.toString() === "0") {
          icon_on_top_left = "clock";
        } else {
          switch (item.eventType.toString()) {
            case "100":
            case "200":
              icon_on_top_left = "sync";
              break;
            case "300":
              icon_on_top_left = "no-sync";
              break;
            default:
              icon_on_top_left = "";
          }
        }
    }
    let icon_on_bottom_left = "";
    if (item.isPhoneCall) {
      icon_on_bottom_left = "phone";
    } else {
      icon_on_bottom_left = "car";
    }

    return {
      name1: item.name1,
      name2: item.name2,
      customerId: item.customerId,
      origin: item.origin,
      eventType: item.eventType,
      outcome: item.outcome,
      visitRule: item.visitRule,
      icon_on_top_left,
      icon_on_bottom_left,
      duration: item.duration,
      fixedStartDate: item.fixedStartDate,
      customerState: item.customerState,
      priority: item.priority
    };
  }
      
  public getMarkerIcon(visit) {
    var caseFound = false;
    var url = this.getImageUrl("red_balloon");
    var x = 25;
    var y = 20;

    if (visit.background !== "" && visit.background !== undefined)  {
      url = this.getImageUrl(`${visit.background}_balloon`);
      caseFound = true;
    }

    if (!caseFound) {
      switch (visit.origin) {
        case 0:
          {
            if ((visit.eventType == 100) || (visit.eventType == 200)) {
              caseFound = true;
            }
            else
              if ((visit.eventType == 0) || (visit.eventType == 300)) {
                url = this.getImageUrl("cyan_balloon");
                caseFound = true;
              }

            break;
          }
        case 200:
          {
            url = this.getImageUrl("cyan_balloon");
            caseFound = true;
            break;
          }
        case 300:
          {
            url = this.getImageUrl("violet_balloon");
            caseFound = true;
            break;
          }
        case 400:
          {
            url = this.getImageUrl("grey_balloon");
            caseFound = true;
            break;
          }
      }
    }

    return {
      url: url,
      labelOrigin: new google.maps.Point(x, y)
    };

  }

  public getMarkerLabel(position, fixedStartDate) {
    if (fixedStartDate != null)
      return "";    

    if ( (position != undefined) && (position != null) )
      position = Number(position) + 1;
      
    return {
      text: String(position),
      fontSize: "12px",
      fontWeight: "bold"
    };
  }

 public getOriginDescription(item: MeetingDisplayItem): string {
    const code = item.origin.toString();
    var suffix = "";
    if (typeof item.priority === 'number') {
      suffix = ` - ${item.priority}`;
    }
    switch (code) {
      case "0": { return `TPL${suffix}`; }
      case "200": { return `Call list SC2${suffix}`; }
      case "300": { return `Priority${suffix}`; }
      case "400": { return `Booster${suffix}`; }
      default: return code; 
    }
  }

  public getEventTypeDescription(item: MeetingDisplayItem): string {

    const code = item.eventType.toString();
    switch (code) {
      case "0": return "Not Recurring";
      case "100": return `Recurring (${item.visitRule})`;
      case "200": return `Recurring same day  (${item.visitRule})`;
      case "300": return "Exception";
      default: return code; 
    }
  }

  public getTextualFunctionality(currentUser) {
    let that = this;
    let userFeatures = [];

    for(let i=0; i<5; i++) {
      if(currentUser.userTypes.includes(i))
        userFeatures[UserFeatures[i.toString()]] = currentUser.userTypes.includes(i);
    }

    return userFeatures;

  }

  public formatTime(msDateStr: string): string {
    if (!msDateStr) return '-';

    const match = /\/Date\((\d+)([+-]\d{4})?\)\//.exec(msDateStr);
    if (!match) return '-';

    const timestamp = parseInt(match[1], 10);
    const offsetStr = match[2] || '+0000';

    const sign = offsetStr.startsWith('-') ? -1 : 1;
    const offsetHours = parseInt(offsetStr.substring(1, 3), 10);
    const offsetMinutes = parseInt(offsetStr.substring(3, 5), 10);
    const offsetTotalMinutes = sign * (offsetHours * 60 + offsetMinutes);

    const correctedTimestamp = timestamp + offsetTotalMinutes * 60 * 1000;
    const date = new Date(correctedTimestamp);

    if (isNaN(date.getTime())) return '-';

    const hours = this.padLeft(date.getUTCHours());
    const minutes = this.padLeft(date.getUTCMinutes());

    return `${hours}:${minutes}`;
  }

  public padLeft(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }

  receiveMessage: any = (e: any) => {
    let that = this;

    const key = e.message ? 'message' : 'data';
    const data = e[key];

    if (e.origin == that.iframeBaseurl && data) {
      localStorage.setItem('signature', data);

      window.removeEventListener('message', that.wheelHandler, true);

      let iframes = document.querySelectorAll('iframe');
      for (let i = 0; i < iframes.length; i++) {
        iframes[i].parentNode.removeChild(iframes[i]);
      }

      localStorage.setItem('signature', "Bearer " + data);
    }
  }

  public createIframeTokenService(wheelHandler, srcIframe) {
    let that = this;

    if (document.getElementById('authiframe')) {
      const iframe = document.getElementById('authiframe');
      iframe.parentNode.removeChild(iframe);

      window.removeEventListener('message', wheelHandler, true);
    }

    let iframe = document.createElement('iframe');

    iframe.id = "authiframe";
    iframe.src = srcIframe;

    window.addEventListener('message', wheelHandler, true);

    iframe.width = "0";
    iframe.height = "0";
    document.querySelector('body').appendChild(iframe);
  }

  private setDefaultVisitFilterOptions(labels: Labels): void {
    const defaults = [
      { key: VisitFilterType.ShowUserPosition.toString(), value: labels.SalesRapPanel['ShowUserPosition'], selected: false, visible: false },
      { key: VisitFilterType.Outcome.toString(), value: labels.SalesRapPanel['ShowReport'], selected: false, visible: true },
      { key: VisitFilterType.Oneshot.toString(), value: labels.SalesRapPanel['ShowOneShot'], selected: true, visible: true },
      { key: VisitFilterType.Booster.toString(), value: labels.FilterOptions['Boosters'], selected: true, visible: true },
      { key: VisitFilterType.Priority.toString(), value: labels.FilterOptions['Priorities'], selected: true, visible: true }
    ];

    this.visitFilterOptionsSource.next(defaults);
  }

  public setVisitFilterOptionsSource(labels: Labels): void {


    const current = this.visitFilterOptionsSource.value;
 
    if (!current || current.length === 0) {
      this.setDefaultVisitFilterOptions(labels);
      return;
    }
    current.forEach(opt => {
      switch (opt.key) {
        case VisitFilterType.ShowUserPosition.toString():
          opt.value = labels.SalesRapPanel['ShowUserPosition'];
          break;
        case VisitFilterType.Outcome.toString():
          opt.value = labels.SalesRapPanel['ShowReport'];
          break;
        case VisitFilterType.Oneshot.toString():
          opt.value = labels.SalesRapPanel['ShowOneShot'];
          break;
        case VisitFilterType.Booster.toString():
          opt.value = labels.FilterOptions['Boosters'];
          break;
        case VisitFilterType.Priority.toString():
          opt.value = labels.FilterOptions['Priorities'];
          break;
      }
    });

    this.visitFilterOptionsSource.next(current);
  }

  public HasFeatures(feature): boolean {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.userTypes && currentUser.userTypes.length > 0) 
      return currentUser.userTypes.includes(feature);
    else
      return false
  }
}



// WEBPACK FOOTER //
// ./src/app/shared.service.ts